<template>
    <div>
        <rkm-area
            v-if="data.form.historico"
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-date-picker
                        range
                        :range-inline="false"
                        start-label="Data inicial"
                        end-label="Data final"
                        v-model="filtro.data"
                    />
                </rkm-col>
            
   
                <rkm-col>
                    <rkm-form-select
                        label="Profissional"
                        :options="profissionaisOptions"
                        v-model="filtro.profissional"
                        show-default-option
                        default-option-text="Todos"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        label="Unidade/Local de Atendimento"
                        :options="unidadesOptions"
                        v-model="filtro.unidade"
                        show-default-option
                        default-option-text="Todos"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click="buscar"
                    >
                        Buscar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="limpar"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-row class="mb-2">
            <rkm-col cols="12" v-if="data.form.historico">

                <rkm-button
                    v-if="data.form.historico.length > 0"
                    @click="selecionarTodos()"
                    color="primary"
                >
                    <template v-if="handleDisabledAtribuidos">
                        Selecionar todos
                    </template>

                    <template v-else>
                        Desmarcar selecionado(s)
                    </template>
                </rkm-button>

                <rkm-button
                    :disabled="flg_processando == 1"
                    v-if="!handleDisabledAtribuidos"
                    @click="agendaPrint()"
                    color="primary"
                >
                    Imprimir atendimento(s) selecionado(s)!
                </rkm-button>

                <rkm-button
                    v-if="!hideHistoricoV1"
                    @click="getUrlHistoricoConectaSUSV1"
                    color="primary"
                >
                    Histórico - ConectaSUS V1
                </rkm-button>
            </rkm-col>
        </rkm-row>

        <rkm-list
            :items="itemsFiltrados"
            @collapse-show="load"
            hide-filters
            hide-pagination
        >
            <template v-slot="{item}">
                <rkm-row>
                    <rkm-col class="flex-grow-0">
                        <rkm-row @click.stop>
                            <rkm-col>
                                <rkm-form-checkbox
                                    :disabled="item.comSigilo"
                                    v-model="item.selecionado"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-col>

                    <rkm-col class="flex-grow-1">
                        <rkm-row v-if="item.origem === 'ambulatorio'">
                            <rkm-col cols="2">
                                <item
                                    :get-value="() => item.dataHora"
                                    label="Data"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <item
                                    :get-value="() => getAmbulatorioTipoLabel(item)"
                                    label="Tipo"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <item
                                    :get-value="() => `${item.lotacao.profissional.nome} - ${item.lotacao.ocupacao.codigo} - ${ item.lotacao.ocupacao.nome}`"
                                    label="Profissional"
                                />
                            </rkm-col>

                            <rkm-col>
                                <item
                                    :get-value="() => `${item.tipoAtendimento}`"
                                    label="Consulta"
                                />
                            </rkm-col>

                            <rkm-col>
                                <item
                                    :get-value="() => `${item.centroCusto.unidade.nomeFantasia}`"
                                    label="Unidade de atendimento"
                                />
                            </rkm-col>

                            <rkm-col
                                v-if="!item.comSigilo"
                                cols="auto"
                            >

                                <rkm-button
                                    :disabled="!item.isAtendimentoSoapAssinado"
                                    color="info"
                                    title="Imprimir (assinados)"
                                    @click="openModalImpressao($event, item, true)"
                                    small
                                >
                                    <rkm-icon icon="signature" />
                                </rkm-button>

                                <rkm-button
                                    color="primary"
                                    title="Imprimir"
                                    @click="openModalImpressao($event, item, false)"
                                    small
                                >
                                    <rkm-icon icon="print" />
                                </rkm-button>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-else-if="item.origem === 'atencao-basica-visita-domiciliar'">
                            <rkm-col cols="2">
                                <item
                                    :get-value="() => item.data"
                                    label="Data"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <item
                                    :get-value="() => 'Atenção básica - Visita domiciliar'"
                                    label="Tipo"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <item
                                    :get-value="() => `${item.usuarioNome} - ${item.ocupacaoDescricao}`"
                                    label="Profissional"
                                />
                            </rkm-col>

                            <rkm-col cols="auto">
                                <rkm-button
                                    color="primary"
                                    title="Imprimir"
                                    @click="printVisitaDomiciliar($event, item)"
                                    small
                                >
                                    <rkm-icon icon="print" />
                                </rkm-button>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-else-if="item.origem === 'pronto-atendimento'">
                            <rkm-col cols="2">
                                <item
                                    :get-value="() => item.dataHora"
                                    label="Data"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <item
                                    :get-value="() => 'Pronto atendimento'"
                                    label="Tipo"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <item
                                    :get-value="() => `${item.lotacao.profissional.nome} - ${item.lotacao.ocupacao.codigo} - ${item.lotacao.ocupacao.nome}`"
                                    label="Profissional"
                                />
                            </rkm-col>

                            <rkm-col>
                                <item
                                    :get-value="() => `${item.tipoAtendimento}`"
                                    label="Consulta"
                                />
                            </rkm-col>

                            <rkm-col>
                                <item
                                    :get-value="() => `${item.centroCusto.unidade.nomeFantasia}`"
                                    label="Unidade de atendimento"
                                />
                            </rkm-col>

                            <rkm-col cols="auto">
                                <rkm-button
                                    :disabled="flg_processando == 1"
                                    color="primary"
                                    title="Imprimir"
                                    @click="printFaaEletronica($event, item)"
                                    small
                                >
                                    <rkm-icon icon="print" />
                                </rkm-button>
                            </rkm-col>
                        </rkm-row>
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-slot:collapse="{item}">
                <rkm-row
                    v-if="'dados' in item"
                    class="p-2"
                >
                    <rkm-col cols="12">
                        <template v-if="item.origem === 'ambulatorio'">
                            <BoxPreAtendimento
                                v-if="item.tipo === 'pre-atendimento'"
                                :item="item.dados"
                            />

                            <BoxAtendimento
                                v-if="item.tipo === 'atendimento'"
                                :item="item.dados"
                            />

                            <BoxPosConsulta
                                v-if="item.tipo === 'pos-consulta'"
                                :item="item.dados"
                            />

                            <BoxAcolhimentoAcsTacs
                                v-if="item.tipo === 'acolhimento-acs-tacs'"
                                :item="item.dados"
                            />

                            <BoxAcolhimentoSaudeBucal
                                v-if="item.tipo === 'acolhimento-saude-bucal'"
                                :item="item.dados"
                            />
                        </template>

                        <BoxAtencaoBasicaVisitaDomiciliar
                            v-if="item.origem === 'atencao-basica-visita-domiciliar'"
                            :item="item.dados"
                        />

                        <BoxProntoAtendimento
                            v-if="item.origem === 'pronto-atendimento'"
                            :item="item.dados"
                        />
                    </rkm-col>
                </rkm-row>
            </template>
        </rkm-list>

        <ModalImpressao
            ref="ModalImpressao"
            :printSigned="printSigned"
            :assinaturaEletronica="printSigned"
            @print="onPrintAmbulatorio"
        />
    </div>
</template>

<script>
// Components.
import BoxAcolhimentoAcsTacs from './components/acolhimento-acs-tacs/Index'
import BoxAcolhimentoSaudeBucal from './components/acolhimento-saude-bucal/Index'
import BoxAtencaoBasicaVisitaDomiciliar from './components/atencao-basica/visita-domiciliar/Index'
import BoxAtendimento from './components/atendimento/Index'
import BoxPreAtendimento from './components/pre-atendimento/Index'
import BoxPosConsulta from './components/pos-consulta/Index'
import BoxProntoAtendimento from './components/pronto-atendimento/Index'
import Item from './components/item/Index'
import ModalImpressao from '@/components/ambulatorio/components/impressao/Modal'

// Mixins.
import {error, file, repository} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {
        BoxAcolhimentoAcsTacs,
        BoxAcolhimentoSaudeBucal,
        BoxAtencaoBasicaVisitaDomiciliar,
        BoxAtendimento,
        BoxPreAtendimento,
        BoxPosConsulta,
        BoxProntoAtendimento,
        Item,
        ModalImpressao
    },
    created() {
        this.repositories = {
            atendimento: this.getConectaSusRepository('ambulatorio.atendimento'),
            pdf: this.getConectaSusRepository('impressao.ambulatorio'),
            prontoAtendimentoPdf: this.getConectaSusRepository('impressao.prontoAtendimento'),
            atencaoBasicaPdf: this.getConectaSusRepository('impressao.atencaoBasica'),
            visitaDomiciliar: this.getConectaSusRepository('atencaoBasica.visitaDomiciliar'),
        }

        this.itemsFiltrados = this.data.form.historico
    },
    props: {
        data: {type: Object, required: true},
        hideHistoricoV1: {type: Boolean, default: false}
    },
    computed: {
        handleDisabledAtribuidos() {

            const atribuidos = this.data.form.historico.filter(item => item.selecionado)

            return atribuidos.length === 0 ? true : false
        },
        historicoPorData() {

            return this.data.form.historico.filter(item => this.itemDentroPeriodo(item))
        },
        historicoPorDataProfissional() {

            if (!this.filtro.profissional) return this.historicoPorData

            return this.historicoPorData.filter(item => this.getItemProfissional(item) === this.filtro.profissional)
        },
        profissionaisOptions() {

            return [...new Set(this.historicoPorData.map(this.getItemProfissional).filter(Boolean))].sort()
        },
        unidadesOptions() {

            return [...new Set(this.historicoPorDataProfissional.map(this.getItemUnidade).filter(Boolean))].sort()
        },
    },
    data: ()  => ({
        flg_processando : 0,
        filtro: {
            data: {
                start: null,
                end: null,
            },
            profissional: null,
            unidade: null,
        },
        itemsFiltrados: [],
        printsAgendados: [],
        printSigned: false,
        itemImpressaoAmbulatorio: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        buscar() {

            this.itemsFiltrados = this.data.form.historico.filter(item => {

                if (!this.itemDentroPeriodo(item)) return false

                if (this.filtro.profissional && this.getItemProfissional(item) !== this.filtro.profissional) return false

                if (this.filtro.unidade && this.getItemUnidade(item) !== this.filtro.unidade) return false

                return true
            })
        },
        limpar() {

            this.filtro.data = {start: null, end: null}
            this.filtro.profissional = null
            this.filtro.unidade = null

            this.itemsFiltrados = this.data.form.historico
        },
        itemDentroPeriodo(item) {

            const inicio = this.paraComparavel(this.formatarData(this.filtro.data.start))
            const fim = this.paraComparavel(this.formatarData(this.filtro.data.end))

            if (!inicio && !fim) return true

            const dataItem = this.paraComparavel(this.getItemData(item))

            if (inicio && dataItem < inicio) return false

            if (fim && dataItem > fim) return false

            return true
        },
        formatarData(date) {

            if (!date) return null

            const dia = String(date.getDate()).padStart(2, '0')
            const mes = String(date.getMonth() + 1).padStart(2, '0')

            return `${dia}/${mes}/${date.getFullYear()}`
        },
        paraComparavel(data) {

            if (!data) return null

            const [dia, mes, ano] = data.split('/')

            return `${ano}${mes}${dia}`
        },
        getItemData(item) {

            return item.origem === 'atencao-basica-visita-domiciliar' ? item.data : item.dataHora
        },
        getItemProfissional(item) {

            return item.origem === 'atencao-basica-visita-domiciliar' ? item.usuarioNome : item.lotacao.profissional.nome
        },
        getItemUnidade(item) {

            return item.origem === 'atencao-basica-visita-domiciliar' ? item.unidadeNomeFantasia : item.centroCusto.unidade.nomeFantasia
        },
        load(item) {

            if (!('dados' in item)) {

                this.$emit('atendimento-clicado', {item, acao: 'visualizacao'})

                let repository = null

                if (item.origem === 'ambulatorio') {

                    if (item.comSigilo) return

                    const repositoriesPorTipo = {
                        'atendimento': this.repositories.atendimento.getHistoricoAtendimentoSoap,
                        'pos-consulta': this.repositories.atendimento.getHistoricoPosConsulta,
                        'acolhimento-acs-tacs': this.repositories.atendimento.getHistoricoAcolhimentoAcsTacs,
                        'acolhimento-saude-bucal': this.repositories.atendimento.getHistoricoAcolhimentoSaudeBucal,
                    }

                    repository = repositoriesPorTipo[item.tipo] || this.repositories.atendimento.getHistoricoPreAtendimento
                }
                else if (item.origem === 'atencao-basica-visita-domiciliar') {

                    repository = this.repositories.visitaDomiciliar.getVisitaDomiciliarForHistorico
                }
                else if (item.origem === 'pronto-atendimento') {

                    repository = this.repositories.atendimento.getHistoricoProntoAtendimentoAtendimento
                }

                this.setLoading()

                repository(item.id)
                    .then(({data}) =>  this.$set(item, 'dados', data))
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())

            
            }
        },
        getUrlHistoricoConectaSUSV1() {
            this.setLoading()

            this.repositories.atendimento.getUrlHistoricoConectaSUSV1(this.data.form.paciente.prontuario)
                .then(response => window.open(response.data.url, '_blank'))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getAmbulatorioTipoLabel(item) {

            if (item.tipo === 'atendimento') {

                return item.isAtendimentoEnfermagem ? 'Atendimento de enfermagem': 'Atendimento'
            }
            else if (item.tipo === 'pos-consulta') {

                return 'Pós-consulta'
            }
            else if (item.tipo === 'acolhimento-acs-tacs') {

                return 'Acolhimento ACS/TACS'
            }
            else if (item.tipo === 'acolhimento-saude-bucal') {

                return 'Acolhimento Saúde Bucal'
            }

            return 'Pré-atendimento'
        },
        openModalImpressao(event, item, assinado) {

            event.stopPropagation();

            const id = assinado ? item.id : item.atendimentoId

            this.printSigned = !!assinado;

            let tipoAtend =  item.tipo;

            this.itemImpressaoAmbulatorio = item

            this.$nextTick(() => {
                this.$refs.ModalImpressao.open(tipoAtend, id);
            });
        },
        onPrintAmbulatorio() {

            if (this.itemImpressaoAmbulatorio) {

                this.$emit('atendimento-clicado', {item: this.itemImpressaoAmbulatorio, acao: 'impressao'})
            }
        },
        unlockLoading() {
            this.flg_processando = 0
            this.unsetLoading()
        },
        printFaaEletronica(event, item) {
            if(this.flg_processando == 1){
                 return
            }
            this.flg_processando = 1
            event.stopPropagation();
            this.setLoading()

            this.$emit('atendimento-clicado', {item, acao: 'impressao'})

            this.repositories.prontoAtendimentoPdf.faa.eletronica(item.id)
                .then(({data, headers}) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unlockLoading())
        },
        printVisitaDomiciliar(event, item) {

            event.stopPropagation();

            this.setLoading()
            this.$emit('atendimento-clicado', {item, acao: 'impressao'})

            this.repositories.atencaoBasicaPdf.fichaVisitaDomiciliar(item.id)
                .then(({data, headers}) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        agendaPrint() {
            this.data.form.historico
                .filter(item => item.selecionado)
                .map(item => {
                    this.processaPrint(item)
                })
        },
        processaPrint(item){
            setTimeout(() => this.printAgendado(item), 500);
        },
        printAgendado(item){
            if(this.flg_processando == 1){
                this.processaPrint(item)
                return
            }
            this.flg_processando = 1
            this.setLoading()

            this.$emit('atendimento-clicado', {item, acao: 'impressao'})

            let request = null;

            if (item.origem === 'ambulatorio') {

                const requestsPorTipo = {
                    'atendimento': () => this.repositories.pdf.atendimento(item.atendimentoId),
                    'pos-consulta': () => this.repositories.pdf.posConsulta(item.atendimentoId),
                    'acolhimento-acs-tacs': () => this.repositories.pdf.acolhimentoAcsTacs(item.atendimentoId),
                    'acolhimento-saude-bucal': () => this.repositories.pdf.acolhimentoSaudeBucal(item.atendimentoId),
                }

                request = (requestsPorTipo[item.tipo] || (() => this.repositories.pdf.preAtendimento(item.atendimentoId)))()
            }
            else if (item.origem === 'pronto-atendimento') {

                request = this.repositories.prontoAtendimentoPdf.faa.eletronica(item.id)
            }
            else if (item.origem === 'atencao-basica-visita-domiciliar') {

                request = this.repositories.atencaoBasicaPdf.fichaVisitaDomiciliar(item.id)
            }

            request
                .then(({data, headers}) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unlockLoading())
        },
        print() {
            this.data.form.historico
                .filter(item => item.selecionado)
                .map(item => {
                    if(this.flg_processando == 1){
                        return
                    }
                    this.flg_processando = 1
                    this.setLoading()

                    this.$emit('atendimento-clicado', {item, acao: 'impressao'})

                    let request = null;

                    if (item.origem === 'ambulatorio') {

                        const requestsPorTipo = {
                            'atendimento': () => this.repositories.pdf.atendimento(item.atendimentoId),
                            'pos-consulta': () => this.repositories.pdf.posConsulta(item.atendimentoId),
                            'acolhimento-acs-tacs': () => this.repositories.pdf.acolhimentoAcsTacs(item.atendimentoId),
                            'acolhimento-saude-bucal': () => this.repositories.pdf.acolhimentoSaudeBucal(item.atendimentoId),
                        }

                        request = (requestsPorTipo[item.tipo] || (() => this.repositories.pdf.preAtendimento(item.atendimentoId)))()
                    }
                    else if (item.origem === 'pronto-atendimento') {

                        request = this.repositories.prontoAtendimentoPdf.faa.eletronica(item.id)
                    }
                    else if (item.origem === 'atencao-basica-visita-domiciliar') {

                        request = this.repositories.atencaoBasicaPdf.fichaVisitaDomiciliar(item.id)
                    }

                    request
                        .then(({data, headers}) => this.openFile(data, headers['content-type']))
                        .catch(this.handleError)
                        .finally(() => this.unlockLoading())
                })
        },
        selecionarTodos(){

            if(this.handleDisabledAtribuidos){

                this.data.form.historico.filter(item => !item.comSigilo).map(item => (item.selecionado = true))
            } else {

                this.data.form.historico.filter(item => !item.comSigilo).map(item => (item.selecionado = false))
            }
        },
    },
    mixins: [error, file, repository],
    watch: {
        'filtro.data': {
            deep: true,
            handler() {

                this.filtro.profissional = null
                this.filtro.unidade = null
            },
        },
        'filtro.profissional'() {

            this.filtro.unidade = null
        },
    },
}
</script>